import { createDynamicSink, createCompositeSink, createConsoleSink } from "../sinks";
import type { PropertyValues, WellKnownPropertyValues, LoggingSink } from "../types";
import { createLogger } from "./createLogger";
import { consoleLoggers } from "./originalConsoleLoggers";

const dynamicSink = createDynamicSink();
const rootSink = createCompositeSink(createConsoleSink(consoleLoggers), dynamicSink);
export const logger = createLogger(
    rootSink,
    () => appName,
    () => attachedGlobalContexts.reduce((prev, current) => ({ ...prev, ...current.getProperties() }), { Application: appName, SourceContext: appName })
);

let appName: string = "Unknown";

let attachedGlobalContexts: GlobalLoggingContextProvider<PropertyValues>[] = [];

export type GlobalLoggingContextProvider<T extends PropertyValues> = {
    getProperties: () => T;
};

function attachContextProvider<T extends WellKnownPropertyValues<{}>>(provider: GlobalLoggingContextProvider<T>): () => void {
    attachedGlobalContexts.push(provider);
    return () => (attachedGlobalContexts = attachedGlobalContexts.filter((p) => p !== provider));
}

export const globalLogConfiguration = {
    attachSink: (sink: LoggingSink) => dynamicSink.attachSink(sink),
    attachContextProvider,
    flush: () => rootSink.flush?.(),
};

export const globalLogContext = {
    setApplication(applicationName: string) {
        appName = applicationName;
    },
};
